import React, { Component } from "react";
import { FilePond } from "react-filepond";
import "filepond/dist/filepond.min.css";
import readXlsxFile from "read-excel-file";
import axios from "axios";
//import excel_ejemplo from '../consola-deshabilitados-test.xlsx'
import { Auth } from "aws-amplify";
import { motivosdes, motivoshab } from "../motivos";

class ImportarExcel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            skus_procesar: [],
            archivo: [],
            notification: <div></div>,
            cargaExitosa: false,
            loadingExcel: false,
            canProcess: false,
            procesando: false,
            loggedUser: "",
            verificoUsuario: false,
        };
        this.leerExcel = this.leerExcel.bind(this);
        this.renderSkuTable = this.renderSkuTable.bind(this);
        this.procesarSkus = this.procesarSkus.bind(this);
    }

    componentDidMount() {
        Auth.currentAuthenticatedUser()
            .then((user) => {
                this.setState({
                    loggedUser: user.username,
                    verificoUsuario: true,
                });
            })
            .catch((error) => {
                let mensaje = "Hubo un error inesperado";
                if (error.message) mensaje = error.message;
                this.setState({
                    notification: (
                        <div className="alert alert-danger">{mensaje}</div>
                    ),
                });
            });
    }

    /**
     * Carga los registros del Excel al array skus_procesar y valida la posicion de las columnas y que sea de un tipo de dato valido
     */
    leerExcel() {
        if (this.state.archivo.length > 0) {
            this.setState({
                notification: <div></div>,
                cargaExitosa: false,
                loadingExcel: true,
                canProcess: false,
            });
            readXlsxFile(this.state.archivo[0]).then((rows) => {
                try {
                    let array_skus = [];
                    rows.forEach((item, index) => {
                        if (index >= 1) {
                            console.log(item);
                            if (!item[0])
                                throw new Error(
                                    `Linea ${index}, el campo Sku es requerido`
                                );
                            if (typeof item[0] !== "number")
                                throw new Error(
                                    `Linea ${index}, Sku debe ser numerico, se encontro el valor ${item[0]}`
                                );
                            if (!item[1])
                                throw new Error(
                                    `Linea ${index}, el campo Solicitado Por es requerido`
                                );
                            if (!item[2])
                                throw new Error(
                                    `Linea ${index}, el campo Motivo es requerido`
                                );

                            if (!item[3])
                                throw new Error(
                                    `Linea ${index}, el campo Comentario es requerido`
                                );

                            if (!item[4])
                                throw new Error(
                                    `Linea ${index}, el campo Accion es requerido`
                                );
                            if (!(item[4] === "HAB" || item[4] === "DES"))
                                throw new Error(
                                    `Linea ${index}, la Accion solo permite valores HAB (para habilitar) o DES (para deshabilitar), se encontro el valor ${item[3]}`
                                );

                            if (item[4] === "DES") {
                                if (!motivosdes.includes(item[2])) {
                                    throw new Error(
                                        `Linea ${index}, el motivo no se encuentra dentro de las opciones de deshabilitar`
                                    );
                                }
                            }
                            if (item[4] === "HAB") {
                                if (!motivoshab.includes(item[2])) {
                                    throw new Error(
                                        `Linea ${index}, el motivo no se encuentra dentro de las opciones de habilitar`
                                    );
                                }
                            }
                            array_skus.push({
                                Sku: item[0],
                                Usuario: this.state.loggedUser,
                                Comentario: item[3],
                                Motivo: item[2],
                                Accion: item[4],
                                Solicitado_por: item[1],
                            });
                        } else {
                            if (item[0].toUpperCase() !== "SKU")
                                throw new Error(
                                    "No se encuentra el campo Sku o esta en otra columna que no es la primera"
                                );
                            if (item[1].toUpperCase() !== "SOLICITADO POR")
                                throw new Error(
                                    "No se encuentra el campo Solicitado por o esta en otra columna que no es la segunda"
                                );
                            if (item[2].toUpperCase() !== "MOTIVO")
                                throw new Error(
                                    "No se encuentra el campo Motivo o esta en otra columna que no es la tercera"
                                );
                            if (item[3].toUpperCase() !== "COMENTARIO")
                                throw new Error(
                                    "No se encuentra el campo Comentario o esta en otra columna que no es la cuarta"
                                );
                            if (item[4].toUpperCase() !== "ACCION")
                                throw new Error(
                                    "No se encuentra el campo Accion o esta en otra columna que no es la quinta"
                                );
                        }
                    });
                    this.setState({
                        notification: (
                            <div className="alert alert-info">
                                Se cargaron con exito {rows.length} skus
                            </div>
                        ),
                        cargaExitosa: true,
                        skus_procesar: array_skus,
                        canProcess: true,
                    });
                } catch (e) {
                    let mensaje = "Hubo un error inesperado";
                    if (e.message) mensaje = e.message;
                    this.setState({
                        notification: (
                            <div className="alert alert-danger">{mensaje}</div>
                        ),
                        cargaExitosa: false,
                    });
                }
                this.setState({
                    loadingExcel: false,
                });
            });
        } else {
            this.setState({
                notification: (
                    <div className="alert alert-danger">
                        No se ha seleccionado archivo
                    </div>
                ),
            });
        }
    }

    /**
     * Recorre el listado de skus para procesar y los muestra en una tabla
     * @returns Contenido de la tabla de los SKUs cargados
     */
    renderSkuTable() {
        return this.state.skus_procesar.map((item, index) => (
            <tr key={index}>
                <td>{item.Sku}</td>
                <td>{item.Solicitado_por}</td>
                <td>{item.Motivo}</td>
                <td>{item.Comentario}</td>
                <td>{item.Accion === "DES" ? "Desactivar" : "Activar"}</td>
                <td>{item.Usuario}</td>
            </tr>
        ));
    }

    /**
     * Espera una cantidad de tiempo
     * @param {int} s Tiempo en segundos
     * @returns Promesa que espera la cantidad de tiempo indicada
     */
    sleep(s) {
        return new Promise((resolve) => setTimeout(resolve, s * 1000));
    }

    /**
     * Procesa el listado de skus por la API de la consola en grupos de 100 y muestra en el front el estado del proceso
     */
    async procesarSkus() {
        if (this.state.skus_procesar.length > 0) {
            try {
                this.setState({
                    procesando: true,
                });
                let procesados = 0;
                let i,
                    j,
                    temp_skus_procesar,
                    chunk = 100;
                for (
                    i = 0, j = this.state.skus_procesar.length;
                    i < j;
                    i += chunk
                ) {
                    temp_skus_procesar = this.state.skus_procesar.slice(
                        i,
                        i + chunk
                    );
                    procesados = procesados + temp_skus_procesar.length;
                    await axios.post(
                        process.env.REACT_APP_API_URL +
                            "/api/v1/registrar_skus",
                        {
                            Skus: temp_skus_procesar,
                        }
                    );
                    console.log(procesados);
                    await this.setState({
                        notification: (
                            <div className="alert alert-primary">
                                Progreso: {procesados} skus
                            </div>
                        ),
                    });
                    await this.sleep(5);
                }
                this.setState({
                    notification: (
                        <div className="alert alert-success">
                            Se procesaron todos los Skus correctamente. En total
                            se procesaron {procesados} skus
                        </div>
                    ),
                    skus_procesar: [],
                });
            } catch (error) {
                let mensaje = "Hubo un error inesperado";
                if (error.response) {
                    console.log(error.response);
                    if (error.response.data.message)
                        mensaje = error.response.data.message;
                }
                this.setState({
                    notification: (
                        <div className="alert alert-danger">{mensaje}</div>
                    ),
                    skus_procesar: [],
                });
            } finally {
                this.setState({
                    procesando: false,
                    skus_procesar: [],
                });
            }
        }
    }

    render() {
        return (
            <div>
                <div className="row mt-5">
                    <div className="col-md-12 text-center">
                        <h2>Cargar Excel</h2>
                        <small>
                            Habilita o deshabilita SKUs en VTEX por medio de un
                            Excel
                        </small>
                        <hr className="mt-5" />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">{this.state.notification}</div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="alert alert-info">
                            <h4 className="alert-heading">
                                Información importante
                            </h4>
                            Si quieres un archivo de prueba para generar tu
                            excel puedes{" "}
                            <a
                                href="https://consola-deshabilitados.s3.amazonaws.com/static/media/consola-deshabilitados-test.2606fa1d.xlsx"
                                download
                                rel="noreferrer"
                                className="alert-link"
                            >
                                descargarlo aquí
                            </a>
                            .
                            <hr />
                            Ten en cuenta que:
                            <ul>
                                <li>El campo SKU debe ser numerico</li>
                                <li>
                                    En el campo acción solo se admiten dos
                                    valores <strong>DES</strong> para
                                    deshabilitar o <strong>HAB</strong> para
                                    habilitar el SKU
                                </li>
                                <li>
                                    Los motivos para deshabilitar un sku deben
                                    encontrarse entre la lista de motivos. Puede
                                    consultar la lista de motivos&nbsp;
                                    <a
                                        data-toggle="collapse"
                                        href="#collapseMotivos"
                                        aria-controls="collapseMotivos"
                                    >
                                        aquí
                                    </a>
                                    <div
                                        className="collapse"
                                        id="collapseMotivos"
                                    >
                                        <div className="card card-body">
                                            <div className="col-12">
                                                <div className="row">
                                                    <div className="col-6">
                                                        <h4>Habilitar:</h4>

                                                        <ul id="mothabilitar">
                                                            {motivoshab.map(
                                                                (item) => {
                                                                    return (
                                                                        <li>
                                                                            {
                                                                                item
                                                                            }
                                                                        </li>
                                                                    );
                                                                }
                                                            )}
                                                        </ul>
                                                    </div>
                                                    <div className="col-6">
                                                        <h4>Deshabilitar:</h4>
                                                        <ul id="motdeshabilitar">
                                                            {motivosdes.map(
                                                                (item) => {
                                                                    return (
                                                                        <li>
                                                                            {
                                                                                item
                                                                            }
                                                                        </li>
                                                                    );
                                                                }
                                                            )}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <FilePond
                            allowMultiple={false}
                            onupdatefiles={(files) => {
                                this.setState({
                                    archivo: files.map((item) => item.file),
                                    notification: <div></div>,
                                    canProcess: false,
                                });
                            }}
                            files={this.state.archivo}
                            acceptedFileTypes={[
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            ]}
                            labelFileTypeNotAllowed="El tipo de archivo no esta admitido, selecciona un Excel xlsx"
                            fileValidateTypeLabelExpectedTypesMap={{
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                                    "Excel",
                            }}
                            labelIdle="Arrastra o carga tu archivo aqui"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        {this.state.loadingExcel ? (
                            <button className="btn btn-secondary" disabled>
                                <span
                                    className="spinner-grow spinner-grow-sm"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                                <span className="sr-only">Procesando...</span>
                            </button>
                        ) : (
                            <button
                                className="btn btn-secondary"
                                onClick={this.leerExcel}
                            >
                                Cargar archivo
                            </button>
                        )}
                    </div>
                    <div className="col-md-6">
                        <div className="d-flex justify-content-end">
                            {this.state.skus_procesar.length > 0 ? (
                                this.state.canProcess ? (
                                    this.state.procesando ? (
                                        <button
                                            className="btn btn-primary"
                                            disabled
                                        >
                                            <span
                                                className="spinner-grow spinner-grow-sm"
                                                role="status"
                                                aria-hidden="true"
                                            ></span>
                                            <span className="sr-only">
                                                Procesando...
                                            </span>
                                        </button>
                                    ) : (
                                        <button
                                            className="btn btn-primary"
                                            onClick={this.procesarSkus}
                                        >
                                            Procesar Skus
                                        </button>
                                    )
                                ) : null
                            ) : null}
                        </div>
                    </div>
                </div>
                {this.state.cargaExitosa ? (
                    <div className="row">
                        <div className="col-12">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Sku</th>
                                        <th>Solicitado Por</th>
                                        <th>Motivo</th>
                                        <th>Comentario</th>
                                        <th>Acción</th>
                                        <th>Usuario</th>
                                    </tr>
                                </thead>
                                <tbody>{this.renderSkuTable()}</tbody>
                            </table>
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

export default ImportarExcel;
